<template>
  <div class="container-fluid">
    <div class="row justify-content-center no-gutters main">
      <div class="col-md-8 col-lg-6 login-form">
        <h4 class="text-center text-white mt-4 mb-4">
          Bienvenue<br>
          Merci de vous identifier pour continuer.
        </h4>

        <LoginForm/>

        <div class="row justify-content-center mt-5">
          <div class="col-6">
            <button type="button" class="btn btn-outline-light btn-sm btn-block"
                    data-toggle="modal"
                    data-target="#recoverymodal" style="margin-bottom: 5px">
              MOT DE PASSE OUBLIÉ ?
            </button>
            <button type="button" class="btn btn-light btn-sm btn-block mt-3" data-toggle="modal"
                    data-target="#registermodal">
              CRÉER MON COMPTE
            </button>
          </div>
        </div>
        <div class="row justify-content-center mt-4">
          <div class="col-11">
            <p class="small text-center text-muted">Si vous rencontrez des difficultés ou si vous
              ne vous souvenez plus de l'adresse email renseignée lors de votre commande veuillez
              contacter la Hotline Bimedia au 025 105 8888 (du lundi au samedi, de 7h à 20h)
            </p>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-11">
            <p class="small text-center text-muted" style="color:#383838!important;">
              {{ version }}
            </p>
          </div>
        </div>
      </div>
      <div class="d-none d-lg-block col-lg-6">
        <img class="w-100 img-container" src="../assets/right_pic.webp"/>
      </div>
    </div>
    <Modal type="recovery" modal-title="Reinitialisation de mot de passe"/>
    <Modal type="register" modal-title="Créer mon compte"/>
  </div>
</template>

<script>
import Modal from '../components/Modal.vue';
import LoginForm from '../components/form/LoginForm.vue';

export default {
  name: 'Login',
  data() {
    return {
      // Module source
      source: this.$route.query.source,
      // Chemin de destination
      path: this.$route.query.path,
      url: this.$route.query.url,
      hash: this.$route.hash || '',
      version: process.env.VUE_APP_VERSION,
    };
  },
  methods: {
    checkSource() {
      if (!this.source && !this.url) {
        this.source = 'Portail';
      }
    },
  },
  created() {
    // eslint-disable-next-line no-console
    console.log(this.version);
    this.checkSource();
  },
  components: {
    LoginForm,
    Modal,
  },
};
</script>
